import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// Data
import { MemberService } from "service/member/service";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListItemText,
  Modal,
  OutlinedInput,
  Pagination,
  Radio,
  RadioGroup,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import MDInput from "components/MDInput";
import DataTable from "examples/Tables/DataTable";
import { text } from "stream/consumers";
import { PromotionService } from "service/promotion/service";
import MDTypography from "components/MDTypography";
import { ShareService } from "service/share/service";
import { object } from "yup";

const getTodayDate = (daysOffset = 0) => {
  const today = new Date();
  today.setDate(today.getDate() + daysOffset);
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

function ShareLog(): JSX.Element {
  const limit = 10;
  const [tableData, setTableData] = useState<any[]>([]);

  const [sortType, setSortType] = useState("AD");
  const [promotionType, setPromotionType] = useState("A");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [startDate, setStartDate] = useState("2025-01-01");
  const [endDate, setEndDate] = useState(getTodayDate());
  const [search, setSearch] = useState("");
  const offset = (currentPage - 1) * limit;

  const [excludeSelfSend, setExcludeSelfSend] = useState<boolean>(true);
  const [showDetailLog, setShowDetailLog] = useState<boolean>(true);

  const handleExcludeSelfSend = (event: React.ChangeEvent<HTMLInputElement>) => {
    setExcludeSelfSend(event.target.checked);
  };

  const handleShowDetailLog = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowDetailLog(event.target.checked);
  };

  const list = async (
    promotionType: string,
    sortType: string,
    search: string,
    startDate: string,
    endDate: string,
    limit: number,
    page: number
  ) => {
    try {
      const promoCode = promotionType === "A" ? "" : promotionType;

      const res = await ShareService.list(
        promoCode,
        sortType,
        search,
        startDate,
        endDate,
        limit,
        page,
        excludeSelfSend ? "Y" : "N",
        showDetailLog ? "Y" : "N"
      );

      console.log(res);
      setTableData(res.list);
      setTotalPages(Math.ceil(res.totalCount / limit));
    } catch (err) {
      console.log(err);
    }
  };

  const csv = async () => {
    try {
      const promoCode = promotionType === "A" ? "" : promotionType;
      const a = document.createElement("a");
      a.href = `${process.env.REACT_APP_HOST}admin/csv4?startDate=${startDate}&endDate=${endDate}&promoCode=${promoCode}&search=${search}&sort=${sortType}`;
      a.download = "";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.log(err);
    }
  };

  const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setCurrentPage(value);
  };

  useEffect(() => {
    setCurrentPage(1);
    list(promotionType, sortType, search, startDate, endDate, limit, currentPage);
  }, [promotionType, startDate, endDate, sortType, excludeSelfSend, showDetailLog]);

  useEffect(() => {
    list(promotionType, sortType, search, startDate, endDate, limit, currentPage);
  }, [currentPage]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={3}
          lineHeight={1}
          width="200px"
        >
          <MDTypography variant="h6">나에게 보내기, 중복 전송 제외</MDTypography>

          <Switch checked={excludeSelfSend} onChange={handleExcludeSelfSend} />
        </MDBox>
        <MDBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={3}
          lineHeight={1}
          width="200px"
        >
          <MDTypography variant="h6">자세한 로그 보기</MDTypography>

          <Switch checked={showDetailLog} onChange={handleShowDetailLog} />
        </MDBox>
        {/* <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            gap: "16px",
            padding: "0 8px",
          }}
        >
          <div
            style={{
              padding: "8px",
              borderRadius: "8px",
              backgroundColor: "white",
              display: "flex",
              gap: "8px",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
              border: "1px solid black",
              cursor: "pointer",
            }}
            onClick={csv}
            role="button"
          >
            <Icon>description</Icon>
            CSV 다운로드
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                검색어
              </span>
              <input
                type="text"
                placeholder="성명, 이메일, 연락처"
                style={{ padding: "8px" }}
                onChange={(e: any) => setSearch(e.target.value)}
              />
              <div
                style={{
                  padding: "8px",
                  backgroundColor: "rgb(30, 155, 107)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "white",
                  borderRadius: "8px",
                  width: "50px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  setCurrentPage(1);
                  list(promotionType, sortType, search, startDate, endDate, limit, currentPage);
                  // list(promotionType, search, startDate, endDate, limit, 0);
                }}
              >
                검색
              </div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                프로모션명
              </span>
              <select
                // value={promotionType}
                style={{ padding: "8px" }}
                onChange={(e: any) => setPromotionType(e.target.value)}
              >
                {promotionData.map((el, index) => (
                  <option value={el.value} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div
              style={{
                display: "flex",
                gap: "4px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#344676",
                  fontFamily: "Pretendard",
                }}
              >
                정렬 기준
              </span>
              <select
                name=""
                id=""
                style={{ padding: "8px" }}
                onChange={(e: any) => setSortType(e.target.value)}
              >
                {sortData.map((el, index) => (
                  <option value={el.value} key={index}>
                    {el.label}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ gap: "16px", display: "flex" }}>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  시작일 선택
                </span>
                <input
                  type="date"
                  value={startDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setStartDate(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#344676",
                    fontFamily: "Pretendard",
                  }}
                >
                  종료일 선택
                </span>
                <input
                  type="date"
                  value={endDate}
                  style={{ padding: "8px" }}
                  onChange={(e: any) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div> */}
        <Card style={{ marginTop: "24px" }}>
          <div style={{ padding: "24px 16px" }}>
            <div style={{ overflowX: "auto" }}>
              <table style={{ minWidth: "1000px", width: "100%" }}>
                <thead>
                  {showDetailLog ? (
                    <tr
                      style={{
                        fontSize: "14px",
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "16px",
                        fontFamily: "Pretendard",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <th>Index</th>
                      <th>생성일자</th>
                      <th>타입</th>
                      <th>이메일</th>
                      <th>로그인타입</th>
                      <th>이름</th>
                    </tr>
                  ) : (
                    <tr
                      style={{
                        fontSize: "14px",
                        width: "100%",
                        textAlign: "center",
                        marginBottom: "16px",
                        fontFamily: "Pretendard",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <th>이메일</th>
                      <th>로그인타입</th>
                      <th>이름</th>
                      <th>공유횟수</th>
                    </tr>
                  )}
                </thead>
                <tbody>
                  {tableData.map((el: any, idx) => (
                    <tr
                      key={idx}
                      style={{
                        fontSize: 12,
                        color: "#000000DE",
                        textAlign: "center",
                        fontFamily: "Pretendard",
                      }}
                    >
                      {Object.keys(el).map((key, index) => {
                        if (key === "id") return null;
                        return (
                          <td
                            style={{
                              borderBottom: "1px solid #0000001A",
                              padding: "16px 8px",
                              whiteSpace: "nowrap",
                            }}
                            key={index}
                          >
                            {el[key] || "-"}
                          </td>
                        );
                      })}
                      {/* <td
                        style={{
                          borderBottom: "1px solid #0000001A",
                          padding: "16px 8px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {el.create_time}
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div style={{ display: "flex", justifyContent: "center", marginTop: "24px" }}>
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                color="secondary"
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&.Mui-selected": {
                      backgroundColor: "#1e9b6b",
                      color: "white",
                    },
                    "&.Mui-selected:hover": {
                      backgroundColor: "#1e9b6b",
                    },
                  },
                }}
              />
            </div>
          </div>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
export default ShareLog;

const sortData = [
  { label: "신청일 최신순", value: "AD" },
  { label: "신청일 오래된순", value: "AA" },
];

const promotionData = [
  { value: "A", label: "전체" },
  { value: "신규 0원(스탠다드)", label: "신규 0원(스탠다드)" },
  { value: "신규회원 무료체험", label: "신규회원 무료체험" },
  { value: "얼리버드", label: "얼리버드(50%)" },
  { value: "기존 트랜스파머 회원", label: "기존 트랜스파머 회원" },
  { value: "대표님 지인", label: "대표님 지인" },
];
